import { render, staticRenderFns } from "./CheckboxBlankOutline.vue?vue&type=template&id=2b4d295d&"
import script from "./CheckboxBlankOutline.vue?vue&type=script&lang=js&"
export * from "./CheckboxBlankOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4d295d')) {
      api.createRecord('2b4d295d', component.options)
    } else {
      api.reload('2b4d295d', component.options)
    }
    module.hot.accept("./CheckboxBlankOutline.vue?vue&type=template&id=2b4d295d&", function () {
      api.rerender('2b4d295d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/CheckboxBlankOutline.vue"
export default component.exports